import { formatHandicapIndex, resolveHandicapIndex, type HandicapFields } from './handicap';

export type PlayerRecordFields = HandicapFields & {
  points?: number;
  elo?: number;
  matches?: number;
  winRate?: number;
  wins?: number;
  losses?: number;
  draws?: number;
  provisional?: boolean;
};

export function playerPoints(player: PlayerRecordFields) {
  return player.points ?? player.elo ?? 0;
}

export function formatRatingChange(change?: number | null) {
  const value = change ?? 0;
  if (value > 0) return `+${value}`;
  return String(value);
}

export function matchWinsLosses(player: PlayerRecordFields) {
  if (typeof player.wins === 'number' && typeof player.losses === 'number') {
    return { wins: player.wins, losses: player.losses, draws: player.draws ?? 0 };
  }

  const matches = Math.max(0, player.matches ?? 0);
  const winRate = Math.max(0, Math.min(100, player.winRate ?? 0));
  const wins = Math.round((matches * winRate) / 100);
  const draws = player.draws ?? 0;
  return { wins, losses: Math.max(0, matches - wins - draws), draws };
}

export function formatPlayerRecord(
  player: PlayerRecordFields,
  labels: {
    handicapShort: string;
    pointsShort: string;
    winsLossesShort: string;
    winsLossesDrawsShort?: string;
    provisional?: string;
  },
) {
  const { wins, losses, draws } = matchWinsLosses(player);
  const recordLabel = labels.winsLossesDrawsShort ?? labels.winsLossesShort;
  const record = draws > 0 || labels.winsLossesDrawsShort
    ? `${recordLabel} ${wins}/${losses}/${draws}`
    : `${labels.winsLossesShort} ${wins}/${losses}`;
  const provisional = player.provisional && labels.provisional ? ` · ${labels.provisional}` : '';
  return `${labels.handicapShort} ${formatHandicapIndex(resolveHandicapIndex(player))} · ${playerPoints(player)} ${labels.pointsShort} · ${record}${provisional}`;
}
